export default "__VITE_ASSET__CCJSmp2S__"